import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import apolloProvider from "./plugins/apollo";
// import VueHtmlToPaper from "vue-html-to-paper";
import Print from "vue-print-nb";
import "./utils/filters";
// Global instruction
Vue.use(Print);
import JsonExcel from "vue-json-excel/JsonExcel.vue";
import VueExcelXlsx from "vue-excel-xlsx";


Vue.use(VueExcelXlsx);
Vue.component("downloadExcel", JsonExcel);

Vue.config.productionTip = false;
// const options = {
//     name: "_blank",
//     specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
//     styles: [
//         // "https://cdnjs.cloudflare.com/ajax/libs/vuetify/2.2.21/vuetify.min.css"
//         "https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css"
//         // "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
//         // "https://unpkg.com/kidlat-css/css/kidlat.css"
//     ]
// };

// Vue.use(VueHtmlToPaper, options);

// const locale = navigator.language || navigator.userLanguage;
// console.log(locale);

const moment = require("moment");
require("moment/locale/nl");
Vue.use(require("vue-moment"), {
    moment
});

// console.log(Vue.moment().locale()); //nl

new Vue({
    router,
    store,
    vuetify,
    apolloProvider,
    render: h => h(App)
}).$mount("#app");
